<template>
  <section v-if="pricing">
    <v-row>
      <v-col class="d-flex justify-end subtotal">
        <table>
          <tbody class="text-right">
            <tr>
              <th scope="row">
                Subtotal
              </th>
              <td>
                {{subtotal | currency}}
              </td>
            </tr>
            <tr v-if="discount">
              <th scope="row">
                Discount
              </th>
              <td>
                ({{discount | currency}})
              </td>
            </tr>
            <tr v-if="full">
              <th scope="row">
                Sales Tax
              </th>
              <td>
                {{tax | currency}}
              </td>
            </tr>
            <tr v-if="full">
              <th scope="row">
                Shipping
              </th>
              <td>
                {{shipping | currency}}
              </td>
            </tr>
            <tr v-if="giftAmount">
              <th scope="row">
                Gift Card
              </th>
              <td>
                ({{giftAmount | currency}})
              </td>
            </tr>
            <tr v-if="full">
              <th scope="row">
                Order Total
              </th>
              <td>
                {{total | currency}}
              </td>
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>
  </section>
</template>

<style lang="scss" scoped>
.subtotal {
  font-size: 24px;
  font-family: $heading-font-family;
}
th {
  padding-right: 24px;
}
td {
  font-weight: 300;
}
</style>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  props: {
    shippingPrices: Object,
    shipping: {
      type: Number,
      default: 0
    },
    tax: {
      type: Number,
      default: 0
    },
    giftAmount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState([
      'pricing',
    ]),
    ...mapGetters([
      'subtotal',
      'discount',
      'discountedTotal',
    ]),
    full: function() {
      return this.shippingPrices && Object.keys(this.shippingPrices).length
    },
    total: function() {
      return this.discountedTotal + this.shipping + this.tax - this.giftAmount
    }
  }
}
</script>